import script from "./Geolocation.vue?vue&type=script&setup=true&lang=ts"
export * from "./Geolocation.vue?vue&type=script&setup=true&lang=ts"

import "./Geolocation.vue?vue&type=style&index=0&id=2a494b8c&lang=scss"

const __exports__ = script;

export default __exports__